import type {MenuOption} from '@spaced-out/ui-design-system/lib/components/Menu/Menu';
import type {ComponentProps} from 'react';

import * as React from 'react';
import {useDispatch, useSelector} from 'react-redux';

import {SimpleDropdown} from '@spaced-out/ui-design-system/lib/components/Dropdown';

import {fetchTaskTypes} from 'src/action-creators/task-and-reminder';
import {selectTaskTypes} from 'src/selectors/task-and-reminder';


type TaskTypeSelectProps = {
  placeholder: string;
  value: string;
  onChange: (taskTypeKey: string) => void;
  disabled?: boolean;
  isActive?: boolean;
  label?: string;
  prependOptions?: Array<{key: string; label: string}>;
  classNames?: ComponentProps<typeof SimpleDropdown>['classNames'];
};

export const TaskTypeSelect = ({
  placeholder,
  value,
  onChange,
  disabled,
  isActive = true,
  label,
  prependOptions = [],
  classNames,
}: TaskTypeSelectProps) => {
  const dispatch = useDispatch();
  const taskTypesFromApi = useSelector(selectTaskTypes);

  React.useEffect(() => {
    if (!isActive) {
      return;
    }
    void dispatch(fetchTaskTypes());
  }, [dispatch, isActive]);

  const options = React.useMemo(
    () => [...prependOptions, ...taskTypesFromApi],
    [prependOptions, taskTypesFromApi],
  );

  return (
    <SimpleDropdown
      classNames={classNames}
      label={label}
      options={options}
      selectedKeys={value ? [value] : []}
      onChange={(option: MenuOption) => {
        onChange(option.key);
      }}
      placeholder={placeholder}
      disabled={disabled}
    />
  );
};
